import { useLoaderData } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { apiGetBestWrestlerWomanListStats } from '../../../components/ui_components/ApiList';
import GeneralRenderingSpecificStats from '../../../components/MobileComponents/Stats/GeneralRenderingSpecificStats';


const BestFemaleWrestlerMobile = () => {
    const wrestlersData = (useLoaderData() as any)?.['data'] ?? [];
    const [searchParams] = useSearchParams();
    const year = searchParams.get('year') || 'globale';

    return (
        <GeneralRenderingSpecificStats
            apiFunctionGetStats={apiGetBestWrestlerWomanListStats}
            title="Rankings"
            stat="importance_score"
            yearStart={year}
            wrestlerDataStart={wrestlersData}
        />
    );
};

export default BestFemaleWrestlerMobile;